import './Layout.css';
import React from 'react'
import { Layout as AntdLayout, Menu as AntdMenu } from 'antd';
import SensorDetails from '../../Containers/SensorDetails/SensorDetails';
import { withRouter } from 'react-router-dom'
import {
	Switch,
	Route,
	Link
} from "react-router-dom";
import Menu from '../../Components/Menu/Menu';

const { Header, Content } = AntdLayout;

class Layout extends React.Component {
	getCurrentSelectedMenuKey() {
		const pathname = this.props.location.pathname;

		if (pathname === '/') {
			return "/sensor/0"
		}
		
		return [pathname];
	}

	renderMenuItem(url, label) {
		return <AntdMenu.Item key={url}><Link to={url}>{label}</Link></AntdMenu.Item>
	}

	renderRoutes() {
		return(
			<Switch>
				<Route exact path="/">
					<SensorDetails isRootForcedFurnace={true}/>
				</Route>
				<Route path="/sensor/:id">
					<SensorDetails/>
				</Route>
			</Switch>
		)
	}

	render() {
		return (
			<AntdLayout className="layout">
				{/* <Header>
					<AntdMenu theme="dark" mode="horizontal" selectedKeys={ this.getCurrentSelectedMenuKey() }>
						{ this.renderMenuItem('/sensor/0', 'Piec') }
						{ this.renderMenuItem('/sensor/1', '1') }
						{ this.renderMenuItem('/sensor/2', '2') }
						{ this.renderMenuItem('/sensor/3', '3') }
						{ this.renderMenuItem('/sensor/4', '4') }
						{ this.renderMenuItem('/analyze', 'Analiza') }
						{ this.renderMenuItem('/settings', 'Ustawienia') }
					</AntdMenu>
				</Header> */}
				<Content>
					<div className="site-layout-content">
						<Menu/>
						{ this.renderRoutes() }
					</div>
				</Content>
			</AntdLayout>
		)
	}
}

export default withRouter(Layout);